import {useCallback, useState} from 'react';

/**
 * Custom hook for the `PasswordInput` component.
 * Manages password visibility toggle state.
 *
 * @returns An object containing:
 * - `isVisible`: Whether the password is currently visible.
 * - `toggleVisibility`: Handler to toggle password visibility.
 * - `inputType`: The input type string (`'text'` or `'password'`).
 */
export const usePasswordInput = () => {
    const [isVisible, setIsVisible] = useState(false);

    /**
     * Toggles the password field between visible (text) and hidden (password) mode.
     */
    const toggleVisibility = useCallback(() => {
        setIsVisible(prev => !prev);
    }, []);

    return {
        inputType: isVisible ? 'text' : 'password' as const,
        isVisible,
        toggleVisibility
    };
};